import { useEffect, useMemo, useRef, useState } from "react";

import { SliderPageWrapper } from "../../layout/sliderPageWrapper/SliderPageWrapper";
import { PaymentMethods } from "./paymentMethods/PaymentMethods";
import { AutoPay } from "./autoPay/AutoPay";

import classes from "./ManageWallet.module.scss";
import { useRootSelector } from "store";
import { useTranslation } from "react-i18next";
import {
  getAccountRestrictions,
  selectedAccountInfo,
} from "store/account/account-selector";

export interface ManageWalletProps {}

export const ManageWallet: React.FC<ManageWalletProps> = () => {
  const { pageDetail } = useRootSelector((state) => state.common);
  const accountInfo = useRootSelector(selectedAccountInfo);
  const { restrictions } = useRootSelector(getAccountRestrictions);

  const actionDisabled: boolean = useMemo(() => {
    return (
      accountInfo?.active !== true ||
      (restrictions.achRestricted && restrictions.cardRestricted)
    );
  }, [accountInfo, restrictions]);

  const [selectedTab, setSelectedTab] = useState<number>(
    pageDetail?.tab ? pageDetail.tab : 0,
  );
  const tabsRef: any = useRef();
  const { t } = useTranslation(["common", "payment"]);
  useEffect(() => {
    const temp = tabsRef.current;
    temp.addEventListener("MDCTabBar:activated", (e: any) => {
      setSelectedTab(e.detail.index);
    });
    return () => {
      temp.removeEventListener("MDCTabBar:activated", (e: any) => {
        setSelectedTab(e.detail.index);
      });
    };
  }, []);

  const renderTab = () => {
    let comp = null;
    if (selectedTab === 0) comp = <PaymentMethods />;
    if (selectedTab === 1) comp = <AutoPay />;
    return comp;
  };

  return (
    <SliderPageWrapper headerTitle={t("common:manage_wallet")}>
      <div className={classes.headWrapper}>
        <div className={classes.ModuleHeadWrapper}>
          <ft-tab-bar activeIndex={selectedTab} ref={tabsRef}>
            <ft-tab
              data-testid="manage-wallet-payment-method"
              label={t("payment:paymentMethodName")}
            ></ft-tab>
            {!actionDisabled && (
              <ft-tab
                data-testid="manage-wallet-autopay"
                label={t("common:autopay_label")}
              ></ft-tab>
            )}
          </ft-tab-bar>
        </div>
      </div>
      <div className={classes.ModuleWrapper}>{renderTab()}</div>
    </SliderPageWrapper>
  );
};
